import { createContext, useContext, useState } from "react";

import { IService, IServiceProps } from "interfaces/Service";

import {
  ContextProviderProps,
  FormError,
  ServiceContextData,
} from "./IServiceContext";

export const ServiceContext = createContext({} as ServiceContextData);

export function ServiceRegisterProvider({
  children,
}: ContextProviderProps): JSX.Element {
  const [service, setService] = useState<IServiceProps>({
    type: "Residencial",
  } as IServiceProps);
  const [services, setServices] = useState<IServiceProps[]>([]);

  const [errors, setErrors] = useState<FormError>({});
  const [searching, setSearching] = useState<boolean>(false);

  async function retrieveService(id: string) {
    
  }

  function resetService() {
    setSearching(true);
    setService({} as IServiceProps);

    setSearching(false);
  }

  function addError(field: string, message: string) {
    const _errors = { ...errors };
    _errors[field] = message;

    setErrors(() => {
      return _errors;
    });
  }

  function removeError(field: string) {
    const _errors = { ...errors };
    delete _errors[field];

    setErrors(() => {
      return _errors;
    });
  }

  return (
    <ServiceContext.Provider
      value={{
        services, 
        setServices,
        service,
        setService,
        errors,
        setErrors,
        addError,
        removeError,
        retrieveService,
        resetService,
        searching,
      }}
    >
      {children}
    </ServiceContext.Provider>
  );
}

export const useServiceRegister = () => {
  return useContext(ServiceContext);
};
